/**
 *
 * Asynchronously loads the component for Mse003
 * Author: Locnt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
